"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ModalChargePageTwo;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _CollapseInfo = _interopRequireDefault(require("../Wizard/CollapseInfo"));
var _ModalChargeDisclosureModal = _interopRequireDefault(require("./ModalChargeDisclosureModal"));
var _ModalChargeRefinementModal = _interopRequireDefault(require("./ModalChargeRefinementModal"));
var _ModalChargeFormula = require("./ModalChargeFormula");
var _utils = require("../../middleware/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ModalChargePageTwo(_ref) {
  var {
    disclosureHandleClose,
    showDisclosure,
    refinementHandleClose,
    showRefinement,
    snapshot
  } = _ref;
  var {
    values: {
      annualPremium,
      payment,
      paymentFrequency
    },
    setFieldValue
  } = (0, _formik.useFormikContext)();
  var closeAndResetRefinementModal = snapshot => {
    refinementHandleClose();
    // We might be able to use setValues instead of looping through.
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var scheduledPremiumVerbiageMap = {
    'semi-annual': 'semi-annually',
    monthly: 'monthly',
    quarterly: 'quarterly'
  };
  var formulaResults = (0, _ModalChargeFormula.calculateAprAndCharge)(paymentFrequency, (0, _utils.parseFloatCurrencyString)(null, annualPremium), (0, _utils.parseFloatCurrencyString)(null, payment));
  var titleText = "Paying your premium of $".concat(annualPremium, " ").concat(scheduledPremiumVerbiageMap[paymentFrequency], " results in an APR of ").concat(formulaResults.aprRate, "% and an additional Annual Payment Mode charge of ").concat((0, _utils.numberToCurrencyString)(formulaResults.apmCharge, 2), ".");
  var label = "Annual Percentage Rate";
  var total = "".concat(formulaResults.aprRate, "%");
  var id = 'annualPercentageRate';
  var contentArray = [{
    label: 'Annual Payment Mode Charge',
    value: "".concat((0, _utils.numberToCurrencyString)(formulaResults.apmCharge, 2)),
    id: 'annualPaymentModeCharge'
  }];
  var disclosureTitle = "View Disclosure About Our Policy's Premium Payment Options";
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h4", null, titleText), /*#__PURE__*/_react.default.createElement(_CollapseInfo.default, {
    label: label,
    total: total,
    id: id,
    contentArray: contentArray,
    openToStart: '0'
  }), /*#__PURE__*/_react.default.createElement(_ModalChargeDisclosureModal.default, {
    handleClose: disclosureHandleClose,
    show: showDisclosure,
    disclosureTitle: disclosureTitle
  }), /*#__PURE__*/_react.default.createElement(_ModalChargeRefinementModal.default, {
    handleClose: closeAndResetRefinementModal,
    snapshot: snapshot,
    show: showRefinement
  }));
}